// extracted by mini-css-extract-plugin
module.exports = {"electionWidgetMainWrapper":"VkXjz","switchTabsWrap":"hOUsX"};